import LeadsListPage from './LeadsListPage';

export default LeadsListPage;
